import React from "react";
import { Gauge } from "@charty/horizontal-stacked-bar-chart/model";
import { DatavizHorizontalStackedBarChart } from "@radarly/models/dataviz";
import { FullFacet } from "@radarly/models/facets";
import { SearchFragmentPivot } from "@radarly/models/search";
import { useFragmentData } from "../../data";
import Loading from "../../loading";
import Inner from "./inner";

export interface SharedWidgetsPivotHorizontalStackedBarChartProps {
  project: number;
  fragment: SearchFragmentPivot;
  dataviz: DatavizHorizontalStackedBarChart;
  pivot: FullFacet;
  against: FullFacet;
  onClickGauge: (uid: Gauge["id"], range?: any, filter?: Gauge["id"]) => void;
  className?: string;
  forceReload?: boolean;
  isFullscreen?: boolean;
  closeFullscreen?: () => void;
  isPNG?: boolean;
}

export default function SharedWidgetsPivotHorizontalStackedBarChart({
  project,
  fragment,
  forceReload,
  isFullscreen,
  closeFullscreen,
  onClickGauge,
  ...props
}: SharedWidgetsPivotHorizontalStackedBarChartProps) {
  const { loading, data } = useFragmentData(project, fragment);
  const _onClickGauge = (
    uid: string | number,
    range?: any,
    filter?: Gauge["id"]
  ) => {
    if (isFullscreen) {
      closeFullscreen();
    }
    onClickGauge(uid, range, filter);
  };
  return (
    <Loading loading={loading} forceReload={forceReload}>
      <Inner
        loading={loading}
        data={data}
        fragment={fragment}
        isFullscreen={isFullscreen}
        onClickGauge={_onClickGauge}
        {...props}
      />
    </Loading>
  );
}
